import { Component, Input, OnInit } from '@angular/core';
import { AiService } from '../../services/ai.service';
import { ToastrService } from 'ngx-toastr';
import { AI_ASSISTANT_NAME } from 'src/app/_core/config/app-config.const';

@Component({
  selector: 'tangram-ai-summary',
  templateUrl: './ai-summary.component.html',
  styleUrls: ['./ai-summary.component.scss']
})
export class AiSummaryComponent implements OnInit {
  @Input() pathwayId: string = '';
  @Input() videoId: string = '';
  @Input() isDashboard: boolean = false;
  @Input() subscriptionActive: boolean = false;

  // Every user-facing label goes through this — the UI never names the
  // underlying model. See AI_ASSISTANT_NAME in app-config.const.ts.
  readonly aiName = AI_ASSISTANT_NAME;

  summary: string = '';
  isLoading: boolean = false;
  isExpanded: boolean = true;
  generatedAt: Date | null = null;
  activeProvider: 'gemini' | 'claude' = 'claude';

  constructor(
    private aiService: AiService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {}

  generateSummary(provider: 'gemini' | 'claude' = 'claude') {
    // return; // TODO: Temporarily disabled for client demo
    this.isLoading = true;
    this.summary = '';
    this.activeProvider = provider;

    const request = this.isDashboard
      ? this.aiService.getTangramSummary(this.pathwayId, provider)
      : this.aiService.getMediaSummary(this.videoId, provider);

    request.subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.success && res.data) {
          this.summary = res.data.summary;
          this.generatedAt = new Date();
        }
      },
      (_error: any) => {
        this.isLoading = false;
        // Toastr is shown globally by HttpAPIInterceptor for all AI errors.
      }
    );
  }

  copySummary() {
    // return; // TODO: Temporarily disabled for client demo
    if (this.summary) {
      navigator.clipboard.writeText(this.summary).then(() => {
        this.toastr.success('Summary copied to clipboard.');
      });
    }
  }
}
